import { FC, memo, useMemo } from 'react'
import { IconButton, Tooltip, IconButtonProps } from '@chakra-ui/react'
import { useValidatePermissions } from 'hooks'

type Props = IconButtonProps & {
  customDisableCondition?: boolean | null
  permissions?: (string | undefined)[]
}

const IconButtonWithPermission: FC<Props> = ({ customDisableCondition = null, permissions, children, ...buttonProps }) => {
  const { validatePermissions } = useValidatePermissions()

  const hasPermission = useMemo(() => {
    return validatePermissions(permissions)
  }, [permissions])

  const condition = customDisableCondition === null ? hasPermission : customDisableCondition

  return (
    <Tooltip isDisabled={condition} label="Você não tem permissão">
      <IconButton isDisabled={!condition} width="max-content" {...buttonProps}>
        {children}
      </IconButton>
    </Tooltip>
  )
}

export default memo(IconButtonWithPermission)
